import React, { useState, useEffect, useRef } from "react";
import { useNavigationStore } from "src/store/navigationStore";

interface TypewriterProps {
  text: string;
  speed?: number;
}

const Typewriter: React.FC<TypewriterProps> = ({ text, speed = 50 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const indexRef = useRef(0); // keep track of the typing index
  const timeoutRef = useRef<NodeJS.Timeout | null>(null); // store timeout id for cleanup
  const isInterrupt = useNavigationStore((state) => state.isInterrupt);

  // Watch for changes in isInterrupt
  useEffect(() => {
    console.log("type writer interrupt: ", isInterrupt);
    if (isInterrupt) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setDisplayedText(text); // Show full text immediately
    }
  }, [isInterrupt, text]);

  useEffect(() => {
    // Only start typing if isInterrupt is false
    if (!isInterrupt) {
      setDisplayedText("");
      indexRef.current = 0;

      const typeCharacter = () => {
        if (indexRef.current < text.length) {
          const char = text.charAt(indexRef.current);
          indexRef.current += 1;
          setDisplayedText((prev) => prev + char);
          timeoutRef.current = setTimeout(typeCharacter, speed);
        }
      };

      timeoutRef.current = setTimeout(typeCharacter, 0);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [text, speed, isInterrupt]);

  return <div className="text-line-height">{displayedText}</div>;
};

export default Typewriter;
